import { ImageLoaderCSSStyleImpl } from '../../../../toolkit/imageloader/imageloadercss';


export class PreferenceImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '121px', 
            height: '129px',
            borderRadius: "5px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferenccard/prefernceimageloadercss.ts